import script from "./ModalAsideComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalAsideComponent.vue?vue&type=script&lang=ts&setup=true"

import "./ModalAsideComponent.vue?vue&type=style&index=0&id=2cde972b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cde972b"]])

export default __exports__